export default __webpack_public_path__ + "static/sa-188520e75af85cb707a8057db05cdfd9.jpg";